import { FirestoreDataConverter } from '@angular/fire/firestore';
import { FormControl, FormGroup } from "@angular/forms";
import { MpProductTypeEnum } from "../enums/mp-product-type.enum";
import { Operation } from './operation.model';
import { Quantity } from "./commerce-configuration.model";
import { ObjectHelper } from "../helpers/object.helper";

export type VariationForm = FormGroup<{
  id: FormControl<string>,
  name: FormControl<string>,
  erpId: FormControl<string>,
  material: FormControl<string | null>,
  printType: FormControl<string | null>,
  format: FormControl<string | null>,
  finish: FormControl<string | null>,
  cutting: FormControl<string | null>,
  drilling: FormControl<string | null>,
  coverMaterial: FormControl<string | null>,
  binding: FormControl<string | null>,
  folding: FormControl<string | null>,
  script: FormControl<string>,
  mpProductTypeId: FormControl<MpProductTypeEnum>,
  pageNumber: FormControl<number>,
  organizationId: FormControl<string>,
  operations: FormControl<Operation[]>,
  quantities: FormControl<Quantity[]>,
  mpVariationId: FormControl<string>,
}>;

/**
 * Model for Commerce Product Variation (Used for Commerce)
 */
export class CommerceVariation {
  id: string;
  name: string;
  erpId: string;
  material: string | null;
  printType: string | null;
  format: string | null;
  finish: string | null;
  cutting: string | null;
  drilling: string | null;
  binding: string | null;
  folding: string | null;
  coverMaterial: string | null;
  script: string;
  mpProductTypeId: MpProductTypeEnum;
  pageNumber: number;
  organizationId: string;
  operations: Operation[] = [];
  mpVariationId: string;
  quantities: Quantity[];

  constructor(data?: Partial<CommerceVariation>) {
    this.id = data?.id ?? '';
    this.name = data?.name ?? '';
    this.erpId = data?.erpId ?? '';
    this.material = data?.material ?? null;
    this.printType = data?.printType ?? null;
    this.format = data?.format ?? null;
    this.finish = data?.finish ?? null;
    this.cutting = data?.cutting ?? null;
    this.drilling = data?.drilling ?? null;
    this.binding = data?.binding ?? null;
    this.folding = data?.folding ?? null;
    this.coverMaterial = data?.coverMaterial ?? null;
    this.script = data?.script ?? '';
    this.mpProductTypeId = data?.mpProductTypeId ?? MpProductTypeEnum.NONE;
    this.pageNumber = data?.pageNumber ?? 0;
    this.organizationId = data?.organizationId ?? '';
    this.operations = data?.operations ?? [];
    this.quantities = data?.quantities ?? [];
    this.mpVariationId = data?.mpVariationId ?? '';
  }

  /**
   * Converter used to convert a variation from firebase
   */
  static converter: FirestoreDataConverter<CommerceVariation> = {
    toFirestore: (variation: CommerceVariation) => {
      return {
        id: variation.id,
        name: variation.name,
        erpId: variation.erpId,
        material: variation.material,
        printType: variation.printType,
        format: variation.format,
        finish: variation.finish,
        cutting: variation.cutting,
        drilling: variation.drilling,
        binding: variation.binding,
        folding: variation.folding,
        coverMaterial: variation.coverMaterial,
        script: variation.script,
        mpProductTypeId: variation.mpProductTypeId,
        pageNumber: variation.pageNumber,
        organizationId: variation.organizationId,
        operations: variation.operations,
        quantities: ObjectHelper.anonymize(variation.quantities),
        mpVariationId: variation.mpVariationId,
      };
    },
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new CommerceVariation({
        ...data,
        id: snapshot.id,
      });
    }
  };
}
